var Vue = require('vue').default

var alert_box = require('./alter.vue')
module.exports = function init_alter_and_modules() {
    class AlertBox {
        constructor() {
            var vm = new Vue({
                render: h => {
                    return h(alert_box)
                }
            }).$mount()
            document.body.appendChild(vm.$el);
            this.component = vm.$children[0]
        }

        show_box(title, name, callback, option) {
            this.component.show_box(title, name, callback, option);
        }

        show_resign(title, name, callback) {
            this.component.show_resign(title, name, callback);
        }

        close_box() {
            this.component.close_box()
        }

        close_type(type, cb) {
            this.component.hide(null, type, cb)
        }

        close_all(cb) {
            this.component.close_all(cb)
        }
    }

    AlertBox.getInstance = (function () {
        let instance;
        return function () {
            if (!instance) {
                instance = new AlertBox()
            }
            return instance
        }
    })()
    AlertBox.getInstance2 = (function () {
        let instance;
        return function () {
            if (!instance) {
                instance = new AlertBox()
            }
            return instance
        }
    })()
    Vue.prototype.$alter = AlertBox.getInstance()
    Vue.prototype.$alter_err = AlertBox.getInstance2()
}